import { v4 } from 'uuid'

const DEBUG = false

class Toast
{
    constructor(msg, type, manager) {
        this.msg = msg
        this.type = type
        this.lifespan = manager.options.toastLifespan
        this.container = manager.container
        this.manager = manager
        this.id = v4()

        this.create()
    }

    create() {
        const toast = document.createElement(`div`)
        toast.classList.add(`toast`, `toast_${this.type}`, `toast_hide`)
        toast.dataset.toastId = this.id
        toast.innerHTML = `<div class="toast__message">${this.msg}</div>`

        if (DEBUG) {
            console.log(this.container)
            console.log(toast)
        }

        this.container.appendChild(toast)

        setTimeout(() => {
            this.getToastSelector().classList.remove('toast_hide')
            this.getToastSelector().style.transition = this.manager.options.toastTransition + 's'
        }, 100)

        setTimeout(() => {
            this.getToastSelector().classList.add('toast_hide')
        }, this.lifespan - this.manager.options.toastTransition * 1000)

        setTimeout(() => {
            this.removeByTimer()
        }, this.lifespan)
    }

    removeByTimer() {
        const toast = this.getToastSelector()
        if (toast) {
            toast.parentNode.removeChild(toast)
        }

        if (this.manager) {
            this.manager.onRemovedToast(this.id)
        }
    }

    getToastSelector() { return this.container.querySelector(`[data-toast-id="${this.id}"]`) }
    getId() { return this.id }
}


class ToastManager {
    constructor(options) {
        this.options = {
            toastLifespan: 5000,
            topOffset: 50,
            spaceBetweenToasts: 10,
            toastTransition: '.5s'
        }
        Object.assign(this.options, options)

        this.toasts = []
        this.container = document.querySelector('body')
    }

    createToast(msg, type) {
        const toast = new Toast(msg, type, this)
        this.toasts.push(toast)
        this.recalculateToastsPosition()

        if (DEBUG) {
            console.log('toasts count: ' + this.toasts.length)
        }
    }

    onRemovedToast(toastId) {
        this.toasts = this.toasts.filter(t => t.getId() !== toastId)
        this.recalculateToastsPosition()

        if (DEBUG) {
            console.log('toasts count: ' + this.toasts.length)
        }
    }

    recalculateToastsPosition() {
        let top = this.options.topOffset

        this.toasts.forEach((t, i) => {
            if (DEBUG) {
                console.log('offset for toast' + top)
            }

            const toast = t.getToastSelector()

            if (toast) {
                toast.style.top = top + 'px'
            }

            top += toast.offsetHeight + this.options.spaceBetweenToasts
        })
    }

}

export default ToastManager